<template>
  <div style="margin-bottom: 8px">
    <div class='bubble-text-label-wrap'>
    <div
      class='bubble-text-label'
      :style="{
        color: fontColor,
        backgroundColor: backgroundColor,
        border: `2px solid ${fontColor}`,
      }"
    >
      {{ labelText }}
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpeechBubble',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelText () {
      return this.item.itemableAttributes.labelText
    },
    fontColor () {
      return this.item.itemableAttributes.backgroundColor
    },
    backgroundColor () {
      return this.item.itemableAttributes.fontColor
    }
  }
}
</script>

<style scoped>
.bubble-text-label-wrap {
  top: -12px;
  right: 8px;
  left: 8px;
  margin: auto -30px;
  position: absolute;
  z-index: 0;
}

.bubble-text-label {
  display: inline-block;
  border-radius: 50px;
  -webkit-box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
  padding: 4px 14px 3px;
  font-size: 11px;
  letter-spacing: 2px;
  align-self: center;
}

.bubble-text-label:after {
  position: absolute;
  background-color: inherit;
  content: '';
  height: 10px;
  width: 10px;
  right: 0;
  left: 0;
  margin: auto;
  bottom: -4px;
  border-bottom: inherit;
  border-left: inherit;
  transform:rotate(-45deg);
  z-index: 0;
}
</style>
